import React, { useState } from 'react';
import { PLANS, PLAN_FEATURE_ROWS, planCellValue } from '../../config/plans';
import './PlanFeatureCompare.css';

export default function PlanFeatureCompare({ selectedPlanId, onSelectPlan }) {
  const [expandedId, setExpandedId] = useState(selectedPlanId || null);

  const toggle = (id) => {
    const next = expandedId === id ? null : id;
    setExpandedId(next);
    onSelectPlan?.(next);
  };

  return (
    <div className="plan-compare">
      <h3 className="plan-compare-title">Compare plans</h3>
      <p className="plan-compare-lead">
        Click a plan to see what you get after upgrade. Pro checkout is instant; Team is sales-assisted.
      </p>

      <div className="plan-compare-cards">
        {PLANS.map((p) => {
          const open = expandedId === p.id;
          return (
            <button
              key={p.id}
              type="button"
              className={`plan-compare-card ${open ? 'plan-compare-card--open' : ''} ${
                p.highlight ? 'plan-compare-card--highlight' : ''
              }`}
              onClick={() => toggle(p.id)}
              aria-expanded={open}
            >
              <span className="plan-compare-card-name">{p.name}</span>
              <span className="plan-compare-card-tag">{p.tagline}</span>
              {open && (
                <div className="plan-compare-card-detail">
                  <p className="plan-compare-upgrade-note">{p.upgradeNote}</p>
                  <ul>
                    {p.features.map((f) => (
                      <li key={f}>{f}</li>
                    ))}
                  </ul>
                </div>
              )}
            </button>
          );
        })}
      </div>

      <div className="plan-compare-table-wrap">
        <table className="plan-compare-table">
          <thead>
            <tr>
              <th scope="col">Feature</th>
              <th scope="col">Free</th>
              <th scope="col">Pro</th>
              <th scope="col">Team</th>
            </tr>
          </thead>
          <tbody>
            {PLAN_FEATURE_ROWS.map((row) => (
              <tr key={row.label}>
                <th scope="row">{row.label}</th>
                <td>{planCellValue(row.free)}</td>
                <td>{planCellValue(row.pro)}</td>
                <td>{planCellValue(row.team)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
